import { DatasyncClient, TransportAdapter } from '@ps-int/datasync-client';
import { Api } from '@ps-int/transport';

import getCloudAPIUrl from './get-cloud-api-url';
import { createLogger } from './loggerFacade';

const logger = createLogger('datasync');

const datasyncClients: Record<string, DatasyncClient> = {};

type DataSyncOptions = { db: string; collection: string; userUid?: string };

const getDatasyncClientCacheKey = ({ db, collection, userUid }: DataSyncOptions) =>
    `${db}:${collection}:${userUid ?? ''}`;

export const getDatasyncClient = ({ db, collection, userUid }: DataSyncOptions) => {
    const cacheKey = getDatasyncClientCacheKey({ db, collection, userUid });

    if (!datasyncClients[cacheKey]) {
        const transport = new TransportAdapter({
            transport: new Api(getCloudAPIUrl(), {
                getAdditionalHeaders: () => ({ 'X-Borigin': 'telemost' }),
            }),
            uid: userUid ?? '',
            db: db,
            collection: collection,
        });
        datasyncClients[cacheKey] = new DatasyncClient({
            transport,
            errorHandler: (error) => {
                logger.error(error, {
                    method: 'DatasyncClient errorHandler',
                    block: 'datasync',
                    type: 'datasyncClientInitError',
                });
            },
        });
    }

    return datasyncClients[cacheKey];
};
